import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TElectronicAddressFormatDM from './TElectronicAddressFormatDM'
import TLanguageTextTranslationDM from './TLanguageTextTranslationDM'

export default class TElectronicAddressTypeDM extends Data {
	public static className = 'TElectronicAddressTypeDM'
	public static primaryKey = 'Id'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	GlyphId?: string
	TimeStamp?: string
	VCard?: string
	Description?: string
	Abbr?: string
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	LanguageDescriptionCalc?: string
	@Type(() => TElectronicAddressFormatDM)
	FormatId?: TElectronicAddressFormatDM
	@Type(() => TLanguageTextTranslationDM)
	LanguageDescriptionChild?: TLanguageTextTranslationDM[]
}